import Select from 'components/core/Select'
import { MeasurementType, WeightType } from 'types/order.types'

export const WEIGHT_TYPE_LABELS: {
    [key in WeightType]: string
} = {
    lbs: 'lbs',
    kgs: 'kgs',
}

export const MEASUREMENT_TYPE_LABELS: {
    [key in MeasurementType]: string
} = {
    in: 'in',
    ft: 'ft',
    cm: 'cm',
    m: 'm',
}

const SEPARATOR = ' / '

export const MEASUREMENTS_OPTIONS = [
    {
        value: `ft${SEPARATOR}lbs`,
        label: `ft / lbs`,
    },
    {
        value: `in${SEPARATOR}lbs`,
        label: 'in / lbs',
    },
    {
        value: `m${SEPARATOR}lbs`,
        label: 'm / lbs',
    },
    {
        value: `ft${SEPARATOR}kgs`,
        label: 'ft / kgs',
    },
    {
        value: `cm${SEPARATOR}kgs`,
        label: 'cm / kgs',
    },
    {
        value: `m${SEPARATOR}kgs`,
        label: 'm / kgs',
    },
]

type MeasurementsTypeSelectProps = {
    label?: string
    weightType?: WeightType
    measurementType?: MeasurementType
    onChange: (weightType: WeightType, measurementType: MeasurementType) => void
}

export const MeasurementsTypeSelect = ({
    label,
    weightType,
    measurementType,
    onChange,
}: MeasurementsTypeSelectProps) => {
    const _onChange = (value: string) => {
        const parts = value.split(SEPARATOR)
        const [measurementType, weightType] = parts
        onChange(weightType as WeightType, measurementType as MeasurementType)
    }

    const value = `${measurementType}${SEPARATOR}${weightType}`

    return (
        <Select
            label={label}
            value={value}
            options={MEASUREMENTS_OPTIONS}
            onSelectedOptionChanged={_onChange}
        />
    )
}
